export default __webpack_public_path__ + "static/snap-f140f4e6ae6ab557f608bdae5d9e5126.png";